import React from 'react';
import {AppBar, Box, CssBaseline, Menu, MenuItem, IconButton, Button,Toolbar,Dialog, TextField,
DialogTitle, DialogContent, DialogActions, Grid , Typography} from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import {  useNavigate,  Link } from 'react-router-dom';
import LockResetIcon from '@mui/icons-material/LockReset';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import newLogo from '../../images/rcor_logo.png'
import FlexBetween from '../../components/FlexBetween';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../styles/theme'
import HomeIcon from '@mui/icons-material/Home';
import buttonStyle from '../../styles/buttonStyle';
import SingleAccordion from '../../components/SingleAccordion';
import JobTask from '../../components/Mechanic/JobTask';
import SpareParts from '../../components/Mechanic/SpareParts';
import DateCalander from '../../components/DateCalander';
import HeaderBox from '../../components/HeaderBox';

const drawerWidth = 210;
const boxStyle = {
    root: {
      backgroundColor: 'white', 
      borderRadius: '5px',
      padding: 1
    },
  };



function MechanicUpdate() {
    const navigate = useNavigate()


    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
        handleCloseMenu()
    };
    const handleClose = () => {
        setOpen(false);
        handleCloseMenu()
    };

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex'}}>
                <CssBaseline />
                <AppBar component="nav" position="fixed" sx={{width: '100%', ml: { sm: `${drawerWidth}px` }, backgroundColor: '#404040', height: '55px',}}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <FlexBetween>
                            <IconButton sx={{ mb:'10px', mr: '5px' }} 
                                size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={() => navigate('/')} color="inherit">
                                <HomeIcon sx={{fontSize: "25px" }}  />
                            </IconButton>
                            <Link to='https://www.rcor.co/'><img src={newLogo} alt='logo' /></Link>
                        </FlexBetween>
                        <Toolbar>
                            <Box>
                      
                                <IconButton
                                    size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} color="inherit">
                                    <AccountCircle sx={{ fontSize: "20px",mr: '5px' }} />
                                    <span style={{ fontSize: '14px' }}> User </span>
                                </IconButton>
                            </Box>
                        </Toolbar>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                        >
                            <MenuItem key='password' onClick={handleClickOpen} sx={{ fontSize: '14px' }}><LockResetIcon sx={{ mr: '10px', fontSize: '18px' }} /> Change Password</MenuItem>
                            <MenuItem key='logout' onClick={()=> navigate('/')} sx={{ fontSize: '14px' }}><PowerSettingsNewIcon sx={{ mr: '10px', fontSize: '18px' }} /> Logout</MenuItem>

                        </Menu>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title" sx={{ fontSize: '15px', textAlign: 'center' }}>
                                Reset Password
                            </DialogTitle>
                            <DialogContent>
                                {/* <ChangePassword handleClose={handleClose} /> */}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose}>Close</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </AppBar>

                
                <Box component="main" sx={{ flexGrow: 1, p: 3, width: `calc(100% - ${drawerWidth}px)`, mt: '40px' }}>
                <Box mt={2}>
        <Grid container spacing={1}>
        <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> MECHANIC ORDER UPDATE</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
            <Button sx={buttonStyle.root} onClick={() => navigate('/mechanic')}>Save</Button>&nbsp;
            <Button sx={buttonStyle.root} onClick={() => navigate('/mechanic')}>Cancel</Button>
          </Grid>
          </Grid>
        </Grid>

                <Grid item xs={12} >
                    <HeaderBox title='Service Order Update By Mechanic'/>
                </Grid>

                <Box sx={boxStyle.root}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item xs={1} >
                                        <TextField fullWidth size='small' label= 'Service No' variant="outlined"required name='Service No' />
                                    </Grid> 
                                    <Grid item xs={1.5} >
                                        <TextField fullWidth size='small' label= 'Name' variant="outlined"required name='Name' />
                                    </Grid>  
                                    <Grid item xs={2} >
                                        <TextField fullWidth size='small' label= 'VRM' variant="outlined"required name='VRM' />
                                    </Grid> 
                                    <Grid item xs={2} >
                                        <TextField fullWidth size='small' label= 'Make' variant="outlined"required name='Make' />
                                    </Grid> 
                                    <Grid item xs={2} >
                                        <TextField fullWidth size='small' label= 'Model' variant="outlined"required name='Model' />
                                    </Grid> 
                                    <Grid item xs={3.5} >
                                        <TextField fullWidth size='small' label= 'Descrption' variant="outlined"required name='Descrption' />
                                    </Grid>
                                    <Grid item xs={1.6} >
                                    <DateCalander  title='Service Order Date' />
                                    </Grid> 
                                    <Grid item xs={4} >
                                        <TextField fullWidth size='small' label= 'Service Order Type' variant="outlined"required name='Service Order Type' />
                                    </Grid> 
                                    <Grid item xs={1.6} >
                                        <TextField fullWidth size='small' label= 'Total Hours' variant="outlined"required name='Total Hours' />
                                    </Grid> 
                                    <Grid item xs={1.6} >
                                        <DateCalander  title='Work Allocation Date' />
                                    </Grid> 
                                    <Grid item xs={1.6} >
                                        <DateCalander  title='Work Start Date' />
                                    </Grid> 
                                    <Grid item xs={1.6} >
                                        <DateCalander  title='Work Completion Date' />
                                    </Grid> 
                                    <Grid item xs={6} >
                                        <TextField fullWidth size='small' label= 'Advice From Supervisor' variant="outlined"required name='Advice From Supervisor' inputProps={{style: {height: '60px'}}}  multiline/>
                                    </Grid> 
                                    <Grid item xs={6} >
                                        <TextField fullWidth size='small' label= 'Comments From Mechanic' variant="outlined"required name='Comments From Mechanic' inputProps={{style: {height: '60px'}}} multiline />
                                    </Grid> 
                                    <Grid item xs={12}>
                                    <HeaderBox title=' << Display Allotted Task And Relted Parts >>'/>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <SingleAccordion component={<JobTask/>} title='Job Tasks'/>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <SingleAccordion component={<SpareParts/>} title=' Spare Parts'/>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </form>
                </Box>
        </Grid>
    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
}


export default MechanicUpdate;